import styled from 'styled-components'

export const Dropdown = styled.div`
    position: relative;

    .dropdown-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 50px;
        padding: 0 10px;
        cursor: default;
        color: ${(props) => {return props.theme.colorPrimary}};

        > div {
            width: 30px;
            height: 30px;
            background-color: rgba(0,0,0,.05);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-right: 10px;
        }

        > span {
            font-size: 1rem;
        }
    }

    .dropdown-body {
        display: none;
        position: absolute;
        top: 50px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        font-size: .9rem;
        font-weight: 400;
        width: 170px;
        box-shadow: 0 5px 20px rgba(0,0,0,.08);

        span {
            height: 40px;
            padding: 7px 10px 0;
            cursor: pointer;

            &:hover {
                background-color: rgba(0,0,0,.03);
            }
        }
    }

    &:hover {
        .dropdown-body {
            display: flex;
            flex-direction: column;
        }
    }
`
